import React from "react";
import { Box, Image } from "@chakra-ui/react";
import { VideoImageViewerProps } from "./VideoOrImage.types";

export const VideoImageViewer: React.FC<VideoImageViewerProps> = (props) => {
  const { video, image, autoplay = false } = props;

  const _video = video?.replace("youtu.be/", "www.youtube.com/watch?v=") || "";

  return (
    <>
      {_video && (
        <Box
          float="none"
          css={{ clear: "both" }}
          /* width: 700px; */
          position="relative"
          paddingBottom="56.25%"
          margin="0 auto"
        >
          {_video && (_video || "").includes("youtube") && (
            <Box
              position="absolute"
              margin="0"
              top="50%"
              left="0"
              transform="translateY(-50%)"
              width="100%"
              height="100%"
              maxHeight="calc(100vh - 100px)"
              borderRadius={4}
              as="iframe"
              src={
                _video.replace("/watch?v=", "/embed/") +
                (autoplay ? "?autoplay=1" : "")
              }
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen;"
              // allowFullScreen
            />
          )}

          {_video && (_video || "").includes("vimeo") && (
            // <AspectRatio ratio={4 / 3}>
            <Box
              position="absolute"
              margin="0"
              top="50%"
              left="0"
              transform="translateY(-50%)"
              width="100%"
              height="100%"
              maxHeight="calc(100vh - 100px)"
              as="iframe"
              src={
                _video.replace("/vimeo.com", "/player.vimeo.com/video") +
                (autoplay ? "?autoplay=1&loop=1" : "")
              }
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; accelerometer;"
              // allowFullScreen
            />
            // </AspectRatio>
          )}
        </Box>
      )}
      {!_video && image && (
        <Image
          objectFit="cover"
          borderRadius={4}
          width="100%"
          fallbackSrc={image}
          src={image}
        />
      )}
    </>
  );
};
